import Swiper from "@theme/swiper";

export default class CarRoad extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.currentOffset = 0;
  }

  /* ================= INIT ================= */

  connectedCallback() {
    this.swiperEl = this.querySelector(".swiper");

    this.bgWrapper = this.querySelector(
      ".animated-banner__background-list-wrapper"
    );

    this.bgItems = this.querySelectorAll(
      ".animated-banner__background-image-wrapper"
    );

    this.sequence = this.querySelector("sequence-animation");

    this.buttonPrev = this.querySelector(".animated-banner__nav-button--prev");
    this.buttonNext = this.querySelector(".animated-banner__nav-button--next");
    this.pagination = this.querySelector(".animated-banner__pagination");

    this.initSwiper();
    this.initButtons();
    this.initSequenceEvents();
  }

  /* ================= SEQUENCE ================= */

  initSequenceEvents() {
    if (!this.sequence) return;

    this.sequence.addEventListener("sequence:end", () => {
      this.sequence.reset();
    });
  }

  /* ================= BUTTONS ================= */

  initButtons() {
    this.buttonNext.addEventListener("click", this.changeBgNext);
    this.buttonPrev.addEventListener("click", this.changeBgPrev);
  }

  disableButtons() {
    this.buttonNext.style.pointerEvents = "none";
    this.buttonPrev.style.pointerEvents = "none";
  }

  enableButtons() {
    this.buttonNext.style.pointerEvents = "";
    this.buttonPrev.style.pointerEvents = "";

    if (this.currentIndex === 0) {
      this.buttonPrev.setAttribute("disabled", "");
    } else {
      this.buttonPrev.removeAttribute("disabled");
    }

    this.buttonNext.removeAttribute("disabled");
    this.buttonNext.setAttribute("aria-disabled", false);
  }

  /* ================= CENTER ================= */

  getCenterShift(el) {
    if (!el) return 0;

    const slideWidth = el.offsetWidth;

    // Banner viewport (not wrapper!)
    const viewportWidth =
      this.bgWrapper.parentElement.offsetWidth;

    return (slideWidth - viewportWidth) / 2;
  }

  applyTransform(activeEl) {
    const centerShift = this.getCenterShift(activeEl);

    this.bgWrapper.style.transform =
      `translateX(${-(this.currentOffset + centerShift)}px)`;

  }

  /* ================= HELPERS ================= */

  getStepWidth(el) {
    const rawWidth = el.offsetWidth;
    const wrapperWidth = this.bgWrapper.offsetWidth;
    const overlap = wrapperWidth * 0.14;

    return rawWidth - overlap;
  }

  /* ================= NEXT ================= */

  changeBgNext = () => {
    if (!this.bgItems.length || !this.sequence) return;

    this.disableButtons();

    const items = [...this.bgWrapper.children];
    const isLast = this.currentIndex === items.length - 1;

    this.sequence.playOnce();

    /* ================= NORMAL NEXT ================= */
    if (!isLast) {
      const nextIndex = this.currentIndex + 1;
      const nextItem = items[nextIndex];

      const stepWidth = this.getStepWidth(nextItem);

      this.currentOffset += stepWidth;
      this.currentIndex = nextIndex;

      this.applyTransform(nextItem);

      const onEnd = () => {
        this.sequence.removeEventListener("sequence:end", onEnd);
        this.enableButtons();
      };

      this.sequence.addEventListener("sequence:end", onEnd, { once: true });

      return;
    }

    /* ================= LAST -> FIRST ================= */

    const firstEl = items[0];
    const currentEl = items[this.currentIndex];

    const clone = firstEl.cloneNode(true);
    clone.style.zIndex = "0";

    currentEl.after(clone);

    const stepWidth = this.getStepWidth(clone);

    requestAnimationFrame(() => {
      this.currentOffset += stepWidth;
      this.applyTransform(clone);
      this.swiper.slideTo(0, 2000);
    });

    const onEnd = () => {
      this.sequence.removeEventListener("sequence:end", onEnd);

      clone.remove();

      /* disable transition */
      this.bgWrapper.style.transition = "none";

      /* go back to first */
      this.currentOffset = -8 * this.bgItems.length;
      this.currentIndex = 0;

      this.applyTransform(items[0]);

      requestAnimationFrame(() => {
        this.bgWrapper.style.transition = "";
      });


      this.bgItems = this.querySelectorAll(
        ".animated-banner__background-image-wrapper"
      );

      this.enableButtons();
    };

    this.sequence.addEventListener("sequence:end", onEnd, { once: true });
  };

  /* ================= PREV ================= */

  changeBgPrev = () => {
    if (!this.bgItems.length || !this.sequence) return;

    this.disableButtons();

    this.sequence.playOnce();

    const items = [...this.bgWrapper.children];

    const currentEl = items[this.currentIndex];

    const prevIndex =
      (this.currentIndex - 1 + items.length) % items.length;

    const prevEl = items[prevIndex];

    const stepWidth = this.getStepWidth(prevEl);

    /* clone */
    const clone = prevEl.cloneNode(true);
    clone.style.zIndex = "0";

    /* append after active */
    currentEl.after(clone);

    /* move forward */
    requestAnimationFrame(() => {
      this.currentOffset += stepWidth;
      this.applyTransform(clone);
    });

    /* cleanup */
    const onEnd = () => {
      this.sequence.removeEventListener("sequence:end", onEnd);

      clone.remove();

      this.currentOffset -= stepWidth * 2 + 10;

      this.bgWrapper.style.transition = "none";

      const updatedItems = [...this.bgWrapper.children];
      const target = updatedItems[prevIndex];

      this.applyTransform(target);

      requestAnimationFrame(() => {
        this.bgWrapper.style.transition = "";
      });

      this.currentIndex = prevIndex;

      this.bgItems = this.querySelectorAll(
        ".animated-banner__background-image-wrapper"
      );

      this.enableButtons();
    };

    this.sequence.addEventListener("sequence:end", onEnd, { once: true });
  };

  /* ================= SWIPER ================= */

  initSwiper() {
    this.swiper = new Swiper(this.swiperEl, {
      speed: 1000,
      spaceBetween: 16,
      allowTouchMove: false,
      navigation: {
        prevEl: this.buttonPrev,
        nextEl: this.buttonNext,
      },
      pagination: {
        el: this.pagination,
        clickable: false,
      }
    });
  }
}

customElements.define("car-road", CarRoad);
